module.exports = __webpack_public_path__ + "static/404-68e9a76c0dc8a2f8acdf8ead6c3d3c2c.png";